import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Amplify from 'aws-amplify';
import { withAuthenticator } from 'aws-amplify-react';
import { updateApiConfigAndLogger } from 'config/api';
import clientAuth from 'config/clientAuth';
import { MuiThemeProvider } from '@material-ui/core';
import theme from 'theme';
import { createLogger, LoggerContextProvider } from './utils/logger';
import { ConfigurationContextProvider } from './utils/config';
import { ConfigurationLoader } from './components/ConfigurationLoader';
import Notification from './components/Notification';
import App from './App.container';
import AuthLogin from './components/Login';
import WithApolloProvider from './components/WithApolloProvider';

const AppWithAuth = withAuthenticator(App, false, [<AuthLogin />]);

export default () => (
  <ConfigurationLoader>
    {(config) => {
      // Initialize AWS Amplify Auth
      Amplify.configure({ Auth: config.get('Auth') });
      clientAuth.configure({ Auth: config.get('clientAuth') });

      // Initial app logger
      const logger = createLogger(config.get('logger'));

      // TODO: tmp solution
      updateApiConfigAndLogger(config, logger);

      return (
        <Router>
          <MuiThemeProvider theme={theme}>
            <ConfigurationContextProvider value={config}>
              <LoggerContextProvider value={logger}>
                <WithApolloProvider config={config}>
                  <AppWithAuth />
                  <Notification />
                </WithApolloProvider>
              </LoggerContextProvider>
            </ConfigurationContextProvider>
          </MuiThemeProvider>
        </Router>
      );
    }}
  </ConfigurationLoader>
);
